/* Raghu  27/10/2022 3075154998 Table Enhancements */
/* Rohini  31/10/2022 3075154998 added the properties for the root */
import React, {useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {
  tablePageRows,
  defaultRows,
} from '../../../.../../../../../constants/ReusableTablePagination';
import {ExpandMore} from '@material-ui/icons';
import FilterGroupTable from './FilterGroupTable';
import {useDispatch} from 'react-redux';
import {fetchFilterGroup} from '../../../.../../../../../redux/reducers/EnableFramework/FilterGroup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {

      backgroundColor: '#f3f3f3',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
export default function ReportMasterRulesTable({
  formData,
  setFormData,
  returnType,
  values,
}) {
  const data = formData.map((o) => ({...o, returnType}));
  const [expanded, setExpanded] = useState();
  const [expandedFilterGroup, setExpandedFilterGroup] = useState();
  const dispatch = useDispatch();
  useEffect(() => {}, []);
  const classes1 = useStyles();
  const columns = [
    {
      title: 'Field Type',
      field: 'fieldType',
    },
    {
      title: 'Field Code',
      field: 'fieldCode',
    },
    {
      title: 'SEQ NO',
      field: 'sequence',
    },
    {
      title: 'Field Length',
      field: 'fieldLength',
      hidden: values.fixedLength?.toLowerCase() === 'no',
    },
    {
      title: 'Format',
      field: 'format',
      render: (rowData) => {
        return rowData.format ? rowData.format : '-';
      },
    },
    {
      title: 'Print Totals',
      field: 'printTotals',
      render: (rowData) => {
        return makeFirstLetterUpperCase(rowData.printTotals === 'none' ? '-' : rowData.printTotals);
      },
    },
  ];

  const makeFirstLetterUpperCase = (str) => (str ? str[0].toUpperCase() + str.slice(1) : '-');

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    if (panel === 'panel2') {
      setExpandedFilterGroup(newExpanded ? panel : false);
      dispatch(fetchFilterGroup(values.filterGroupId));
    } else {
      setExpanded(newExpanded ? panel : false);
    }
  };
  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table">
          <div className="form-row my-2 mx-1">
            <div className="col-sm-4 col-lg-3 detailed-structure ">
              <b>Code:</b> {values.code}
            </div>
            <div className="col-sm-2 col-lg-1 detailed-structure  ">
              <b>Separator:</b> {values.seperator}
            </div>
            <div className="col-sm-2  col-lg-3 detailed-structure ">
              <b>File Type:</b> {values.type}
            </div>
            <div className="col-sm-4 col-lg-2 detailed-structure  ">
              <b>Fixed Length:</b> {makeFirstLetterUpperCase(values.fixedLength)}
            </div>
            <div className="col-sm-4 col-lg-3 detailed-structure ">
              <b>Description:</b> {values.description}
            </div>
          </div>
          <div className={`${classes1.root} mt-3`}>
            <Accordion
              className="accordion-styling"
              expanded={expanded === 'panel1'}
              onChange={handleAccordionChange('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>Fields </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <GuiTable
                  title=""
                  columns={columns}
                  data={data}
                  onSelectionChange={(rows, currentRow) => {
                    setFormData(rows);
                  }}
                  options={{
                    toolbar: false,
                    search: false,
                    pageSize: defaultRows,
                    pageSizeOptions: tablePageRows,
                    emptyRowsWhenPaging: false,
                    paging: false,
                    headerStyle: {
                      fontWeight: 'bold',
                    },
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <div className={`${classes1.root} mt-3`}>
            <Accordion
              className="accordion-styling"
              expanded={expandedFilterGroup === 'panel2'}
              onChange={handleAccordionChange('panel2')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>Filter Group </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <FilterGroupTable />
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </Grid>
    </>
  );
}
